import React from "react";
import { COLORS } from "../../constants";

export default function LineDivider({ children, style, className }) {
    return (
        <div className={className} style={{ height: "1px", backgroundColor: COLORS.GRAY, ...style }}>
            {children}
        </div>
    );
}
